import { mapName } from '../game/maps';
import { CAMPAIGN, campaignSettings, isLevelOpen } from '../game/campaign';
import { isHost, lobby, net, profile, screen, showToast } from '../store';
import { Stars } from './common';

export function Campaign() {
  const p = profile.value;
  const stars = p?.stats.campaignStars ?? {};
  const total = Object.values(stars).reduce((a, b) => a + b, 0);
  const current = lobby.value?.settings.campaignLevelId;

  const pick = (id: string) => {
    const level = CAMPAIGN.find((l) => l.id === id);
    if (!level) return;
    if (!isHost.value) {
      showToast('Only the host picks the level.');
      return;
    }
    if (!isLevelOpen(level, stars)) {
      showToast('Clear the previous level first.');
      return;
    }
    net.value?.send({ t: 'updateSettings', settings: campaignSettings(level) });
    screen.value = 'lobby';
  };

  return (
    <div class="screen">
      <div class="campaign">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 12, flexWrap: 'wrap' }}>
          <div>
            <h1>Campaign</h1>
            <p class="muted">Thirty levels against the raiders. Clear within par for two stars, flawless for three.</p>
          </div>
          <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
            <span class="chip num">★ {total} / {CAMPAIGN.length * 3}</span>
            <button class="btn" onClick={() => (screen.value = 'lobby')}>
              Back to lobby
            </button>
          </div>
        </div>
        <div class="level-grid">
          {CAMPAIGN.map((l) => {
            const open = isLevelOpen(l, stars);
            const got = stars[l.id] ?? 0;
            return (
              <button
                key={l.id}
                class={`level-tile${open ? '' : ' locked'}`}
                style={current === l.id ? { borderColor: 'var(--accent)', boxShadow: '0 0 0 1px var(--accent)' } : undefined}
                onClick={() => pick(l.id)}
                aria-label={`Level ${l.index}, ${l.name}${open ? '' : ', locked'}`}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                  <span class="num-lbl num">{String(l.index).padStart(2, '0')}</span>
                  <Stars n={got} />
                </div>
                <div class="card-name">{l.name}</div>
                <div class="card-desc">{l.blurb}</div>
                <div class="muted num" style={{ fontSize: 12, marginTop: 'auto' }}>
                  {mapName(l.map)} · {l.enemies.count} raiders · par {l.parRounds}
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
